import { toast } from 'react-toastify';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from './types';
import { apiService } from '../../utils/apiRequest';
import { resetFranchise } from './franchiseActions';

// Action to indicate login request has started
export const loginRequest = () => ({ type: LOGIN_REQUEST });

// Action to handle successful login and store tokens in state
export const loginSuccess = (accessToken, refreshToken, userData) => {
    return {
        type: LOGIN_SUCCESS,
        payload: { accessToken, refreshToken, userData },
    };
};

// Action to handle logout
export const logoutUser = () => {
    return (dispatch) => {
      

        dispatch({  type: LOGOUT,});
         dispatch(resetFranchise());

    };
};

// Action to handle login failure
export const loginFailure = (error) => ({ type: LOGIN_FAILURE, payload: error });

// Function to fetch access token using username and password
export const getAccessToken = (username, password) => {
    return async (dispatch) => {
        dispatch(loginRequest()); // Dispatch request action before API call

        try {
            // Fetching API credentials from environment variables
            const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
            const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
            const api = process.env.REACT_APP_AUTH_API;
                   
            // Making API request to get access token
            const responseData = await apiService(api, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    grant_type: 'password',
                    client_id: CLIENT_ID,
                    client_secret: CLIENT_SECRET,
                    username: username.trim(),
                    password: password.trim(),
                }),
            });

            // Check if tokens are received successfully
            if (responseData.access_token && responseData.refresh_token) {
                
                // Proceed with login using the access token
                dispatch(loginWithToken(responseData.access_token, username, password));
            } else {
                // Dispatch failure action if login fails
                dispatch(loginFailure('Login failed. Please check your credentials.'));
                toast.error(responseData.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true, // Hides the bottom timer line
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "dark",
                    style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" } // Custom Red Background
                });
                
            }
        }catch (err) {
            dispatch(loginFailure('Login failed. Please check your credentials.'));
        
            // Extract just the message part
            const errorMessage ='Login failed. Please check your credentials.'
        
            toast.error(errorMessage, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "dark",
                style: {
                    backgroundColor: "#D32F2F",
                    color: "#fff",
                    fontWeight: "500"
                }
            });
        }
    };
};

// Function to log in using access token
export const loginWithToken = (accessToken, username, password) => {
    return async (dispatch) => {

        dispatch(loginRequest()); // Dispatch request action before API call

        try {
            const loginapi = process.env.REACT_APP_API_URL + 'login';

            // Making API request to authenticate the user
            const response = await apiService(loginapi, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,  
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_name: username.trim(),  
                    password: password.trim(),  
                }),
            });
            const data = response;
            // console.log(" Response Data:", data);
            if (data.status == "success") {

                dispatch(loginSuccess(accessToken, null, data)); // Refresh token is already stored
            } else {
                dispatch(loginFailure('Login failed with access token.'));
                toast.error(data.message || 'Login failed.',

                    {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: true, // Hides the bottom timer line
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "dark",
                        style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" } // Custom Red Background
                    }


                );
            }
        } catch (err) {
            console.error('Error during login:', err);
            dispatch(loginFailure('An error occurred during login.'));
            toast.error('An error occurred during login.',

                {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true, // Hides the bottom timer line
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "dark",
                    style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" } // Custom Red Background
                }

            );
        }
    };
};

// Function to log in using SSO JWT token
export const loginWithSSOToken = (token) => {
    return async (dispatch) => {
        dispatch(loginRequest());

        try {
            const ssoBase = process.env.REACT_APP_SUITECRM_BASE_URL; // root SuiteCRM
            const ssoUrl = `${ssoBase}/index.php?entryPoint=ssoLogin&token=${token}`;
            const response = await fetch(ssoUrl);
            const data = await response.json();
            // console.log("SSO Response Data:", data);    
           
            if (data.status === "success") {
  
                // fetch access token from function getAccessTokenbydata
                const access_token = await getAccessTokenbydata(data);
                // console.log("Session Token:", access_token);
                    
                // Persist in Redux
                dispatch(loginSuccess(access_token, null, data));

                // Persist in localStorage so user stays logged in across refresh
                localStorage.setItem("authToken", access_token);
                localStorage.setItem("userData", JSON.stringify(data));
            } else {
                dispatch(loginFailure(data.message || "SSO login failed"));
            }
        } catch (err) {
            console.error("SSO login error:", err);
            dispatch(loginFailure("An error occurred during SSO login"));
        }
    };
};

// Function to fetch access token using SSO response data
export const getAccessTokenbydata = async (data) => {
  try {
    // Fetching API credentials from environment variables
    const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
    const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
    const api = process.env.REACT_APP_AUTH_API; // e.g. https://yourcrm.com/Api/access_token
    const username = process.env.REACT_APP_API_USERNAME; 
    const password = process.env.REACT_APP_API_PASSWORD;

    // Making API request to get access token
    const responseData = await apiService(api, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        grant_type: 'password',
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        username: username,
        password: password,
      }),
    });

    if (responseData.access_token && responseData.refresh_token) {
      return responseData.access_token;
    } else {
      console.error("OAuth2 error:", responseData);
      throw new Error(responseData.message || "Failed to get access token");
    }
  } catch (err) {
    console.error("getAccessTokenbydata error:", err);
    throw err;
  }
};
